import { handleActions } from 'redux-actions';

import * as actions from './webSocketQCSActions';
import { mkWebSocketQCSStore } from './webSocketQCSTypes';

const webSocketQCSReducer = handleActions({

  // [actions.sendWebSocketQCSMessage]:
  //   (state) => state,
  //
  // [actions.getWebSocketQCSMessage]:
  //   (state) => state,

  [actions.setWebSocketQCSReadyState]:
    (state, { payload }) => state.merge({ readyState: payload }),

}, mkWebSocketQCSStore());

export const WEB_SOCKET_QCS_REDUCER_KEY = 'webSocketQCSStore';
export default webSocketQCSReducer;
